import { ChangeDetectionStrategy, Component, computed, OnDestroy, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { OfflineOrderService } from '@order/feature';
import { SdvorCustomPaginationComponent } from '@sdvor/shared/ui';
import { NoOrdersBlockComponent, OrderListItemComponent } from '../../../components';

@Component({
  selector: 'sd-offline-orders-list',
  imports: [SdvorCustomPaginationComponent, RouterLink, OrderListItemComponent, NoOrdersBlockComponent],
  templateUrl: './offline-orders-list.component.html',
  styleUrl: './offline-orders-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfflineOrdersListComponent implements OnInit, OnDestroy {
  PAGE_SIZE = 20;
  SORT_TYPE = 'byDate';

  currentPage: number;

  ordersList = toSignal(this.offlineOrderService.getOrderList());
  loading = toSignal(this.offlineOrderService.getOrderListLoading());
  pagination = computed(() => this.ordersList()?.pagination);
  orders = computed(() => this.ordersList()?.orders ?? []);

  constructor(private offlineOrderService: OfflineOrderService) {}

  ngOnInit(): void {
    this.loadOrderList();
  }

  ngOnDestroy(): void {
    this.offlineOrderService.clearOrderList();
  }

  changePage(page: number): void {
    this.currentPage = page;
    this.loadOrderList();
  }

  loadOrderList(): void {
    this.offlineOrderService.loadOrderList({
      pageSize: this.PAGE_SIZE,
      sort: this.SORT_TYPE,
      currentPage: this.currentPage,
    });
  }
}
